import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flow"],
  _excluded2 = ["flow"];
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
// TODO: Remove once consumers are on TS
export const EnrollExistingDecision = {
  ENROLLED: 'ENROLLED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  DID_NOT_ENROLL: 'DID_NOT_ENROLL'
};
export default class FlowRevision extends createImmutableObjectClass({
  associatedBulkEnrollment: null,
  version: null,
  timestamp: null,
  updateType: null,
  portalId: null,
  flowId: null,
  flow: null,
  enrollExistingDecision: 'NOT_APPLICABLE'
}, {
  fromJSON: _ref => {
    let {
        flow
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      flow: flow && new Flow(flow)
    });
  },
  toJSON: _ref2 => {
    let {
        flow
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      flow: flow && flow.toJSON()
    }, rest);
  }
}) {
  getAssociatedBulkEnrollment() {
    return this.associatedBulkEnrollment;
  }
  getEnrollExistingDecision() {
    return this.enrollExistingDecision;
  }
  getVersion() {
    return this.version;
  }
  getTimestamp() {
    return this.timestamp;
  }
  getFlowId() {
    return this.flowId;
  }
  getFlow() {
    return this.flow;
  }
  getUpdateType() {
    return this.updateType;
  }
  toHydratedHybridFlowRevision() {
    return {
      flowId: this.getFlowId(),
      version: this.getVersion(),
      timestamp: this.getTimestamp(),
      updateType: this.getUpdateType(),
      portalId: this.portalId,
      enrollExistingDecision: this.getEnrollExistingDecision(),
      flow: this.getFlow().toHybridFlowInterface(),
      associatedBulkEnrollment: this.getAssociatedBulkEnrollment(),
      portalFlowVersion: {
        flowId: this.getFlowId(),
        portalId: this.portalId,
        version: this.getVersion()
      }
    };
  }
}